import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionTechnologiesComponent } from './component/section-technologies.component';



@NgModule({
  declarations: [
    SectionTechnologiesComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    SectionTechnologiesComponent
  ]
})
export class SectionTechnologiesModule { }
